import Vue from 'vue'
import moment from 'moment'

moment.locale('pt-BR')

const formatDate = (value: string, format: string = 'DD/MM/YYYY hh:mm') => moment(value).format(format)

Vue.filter('date', formatDate)
